import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  logoUrl: PropTypes.string,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, logoUrl = '/images/logo.png', sx }) {
  // OR
  const logo = <Box component="img" src={logoUrl} sx={{ width: 70, height: 70, objectFit: 'contain', ...sx }} />;

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
